import * as React from "react";

export const Cross = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.57564 3.57576C3.80995 3.34145 4.18985 3.34145 4.42417 3.57576L7.9999 7.1515L11.5756 3.57576C11.81 3.34145 12.1899 3.34145 12.4242 3.57576C12.6585 3.81007 12.6585 4.18997 12.4242 4.42429L8.84843 8.00002L12.4242 11.5758C12.6585 11.8101 12.6585 12.19 12.4242 12.4243C12.1899 12.6586 11.81 12.6586 11.5756 12.4243L7.9999 8.84855L4.42417 12.4243C4.18985 12.6586 3.80995 12.6586 3.57564 12.4243C3.34132 12.19 3.34132 11.8101 3.57564 11.5758L7.15137 8.00002L3.57564 4.42429C3.34132 4.18997 3.34132 3.81007 3.57564 3.57576Z"
    />
);
